import { useLayoutEffect, useRef, type RefObject } from 'react';
import { attachModalFocus } from './modalFocus';

export function useModalFocus<T extends HTMLElement>(dialog: RefObject<T>, onClose: () => void, enabled = true) {
  const close = useRef(onClose); close.current = onClose;
  useLayoutEffect(() => enabled && dialog.current ? attachModalFocus(dialog.current, () => close.current()) : undefined, [dialog, enabled]);
}
